/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { createContext, useContext } from "react";
import { Role } from "~/generated/graphql";
import { useFetchCustomers } from "./useFetchCustomers";

type ContextValues = Pick<ReturnType<typeof useFetchCustomers>, "customers"> & {
  userRole: Role;
  showCustomerSelector: () => void;
  selectedCustomer: {
    id: string;
    name: string;
    organizationName: string;
  } | null;
  shouldShowNoCustomerMessage: boolean;
  hideNoCustomerMessage: () => void;
};

export const CustomersContext = createContext<ContextValues | undefined>(
  undefined
);
CustomersContext.displayName = "CustomersContext";

export function useCustomers() {
  const context = useContext(CustomersContext);

  if (context === undefined) {
    throw new Error("CustomersContext must be used within a CustomersProvider");
  }

  return context;
}
